import { Column, Row } from '@unistocks/components/layout/flex';
import { ProgressBar } from '@unistocks/components/progress-bar/progress-bar';
import { Paragraph } from '@unistocks/components/text/text';
import { SavingsGoalProps } from '@unistocks/features/savings-goals/components/savings-goal-props';
import { SavingsGoalDataPoint } from '@unistocks/proxy/axios-client';
import { formatCurrency } from '@unistocks/shared/localization/index.ts';
import { memo } from 'react';
import { ViewProps } from 'tamagui';

export const SavingsGoalProgressBar = memo<SavingsGoalProps & ViewProps>(
  ({ savingsGoal, goalCalculation, ...props }) => {
    const currentValue = goalCalculation?.progress.find(
      value => value.type === SavingsGoalDataPoint.CurrentValue
    );
    const progress =
      goalCalculation?.progress.length && savingsGoal?.goalValue
        ? Math.min(goalCalculation.progress.at(-1)!.value / savingsGoal.goalValue, 1)
        : 0;

    return (
      <Column {...props}>
        <ProgressBar value={progress} />
        {currentValue && savingsGoal.goalValue ? (
          <Row justifyContent="space-between">
            <Paragraph size={'$2'} fontWeight={'$7'}>
              {formatCurrency(currentValue.value, savingsGoal.currency.code, {
                maximumFractionDigits: 0
              })}
            </Paragraph>
            <Paragraph size={'$2'} fontWeight={'$7'}>
              {formatCurrency(savingsGoal.goalValue, savingsGoal.currency.code, {
                maximumFractionDigits: 0
              })}
            </Paragraph>
          </Row>
        ) : null}
      </Column>
    );
  }
);

SavingsGoalProgressBar.displayName = 'SavingsGoalProgressBar';
